import { Component } from '@angular/core';

@Component({
    template: require('./page-not-found.component.html'),
})
export class PageNotFoundComponent { }
